import { AvatarSize } from 'components/Avatar/avatar.types';
import { IconSize } from 'components/Icon/icon.types';

interface GetNextIconSizeProps {
  currentSize: IconSize | AvatarSize;
  larger: boolean;
  delta: number;
}

export const getNextIconSize = ({ currentSize, larger = true, delta = 1 }: GetNextIconSizeProps): IconSize => {
  let nextSize: IconSize;
  switch (currentSize) {
    case 'xs':
      nextSize = larger ? 'sm' : 'xs';
      break;
    case 'sm':
      nextSize = larger ? 'md' : 'xs';
      break;
    case 'md':
      nextSize = larger ? 'lg' : 'sm';
      break;
    case 'lg':
      nextSize = larger ? 'xl' : 'md';
      break;
    case 'xl':
      nextSize = larger ? '2xl' : 'lg';
      break;
    case '2xl':
      nextSize = larger ? '2xl' : 'xl';
      break;
    default:
      nextSize = currentSize as IconSize;
      break;
  }

  if (delta > 1) {
    nextSize = getNextIconSize({ currentSize: nextSize, larger, delta: delta - 1 });
  }

  return nextSize;
};
